import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';

/**
 * Phase F9.4 · Regole della Community / Community Rules.
 * Contenuto in it/en `communityRules.json` — breve, concreto, coerente IT/EN.
 */
const SECTION_IDS = [
  'voice_first',
  'age',
  'adult_content',
  'minors',
  'respect',
  'legality',
  'integrity',
  'report',
  'block',
  'enforcement',
];

const LAST_UPDATED = '2026-08-24';

const CommunityRulesPage = () => {
  const { t } = useTranslation('communityRules');
  const sections = SECTION_IDS.map((id) => ({
    id,
    title: t(`sections.${id}`),
  }));

  return (
    <LegalPageLayout
      namespace="communityRules"
      eyebrow={t('eyebrow')}
      title={t('title')}
      subtitle={t('subtitle')}
      lastUpdated={LAST_UPDATED}
      sections={sections}
      testId="community-rules-page"
    >
      {SECTION_IDS.map((id) => (
        <LegalSection
          key={id}
          id={id}
          title={t(`sections.${id}`)}
          body={t(`body.${id}`, { defaultValue: '' })}
          testId={`community-rules-section-${id}`}
        />
      ))}
    </LegalPageLayout>
  );
};

export default CommunityRulesPage;
